var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:[
    'ccos-system__colors',
    {
        'ccos-system__colors--preview': _vm.preview,
    } ]},_vm._l((_vm.colors),function(color){return _c('li',{key:color.guid,staticClass:"ccos-system__color",class:{
            'ccos-system__color--selected': _vm.value === color.guid,
        },style:({
            'background-color': color.hex,
        }),attrs:{"title":color.name},on:{"click":function($event){return _vm.select(color)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }